import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { Button } from '@aeris/ui'

import {
  confirmDesktopUi,
  readDesktopUi,
  updateReady,
} from '../lib/desktop-ui.ts'
import { isDesktop } from '../lib/desktop.ts'

/**
 * "Atualização pronta — Recarregar" (F213, ADR-0040).
 *
 * O desktop baixa a tela nova do servidor em segundo plano; esta faixa diz que
 * ela está pronta. **Nunca recarrega sozinha**: o carrinho do PDV mora na
 * memória desta página, e uma tela que se recarregasse no meio de uma venda
 * seria pior que a versão velha. Quem recarrega é a pessoa, quando puder.
 *
 * Ao montar, avisa o shell que a página abriu — sem esse aviso uma versão nova
 * que quebra na partida é desfeita na abertura seguinte.
 */
export const DesktopUiUpdate = () => {
  const desktop = isDesktop()

  useEffect(() => {
    if (desktop) void confirmDesktopUi()
  }, [desktop])

  const status = useQuery({
    queryKey: ['desktop-ui'],
    queryFn: async ({ signal }) => await readDesktopUi(signal),
    enabled: desktop,
    refetchInterval: 60_000,
    retry: false,
  })

  if (!updateReady(status.data ?? null)) return null

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-3 bg-(--surface-raised) px-4 py-2 text-(length:--text-sm) text-(--text-primary) border-b border-(--border-subtle)"
    >
      <span>Atualização do Aeris pronta.</span>
      <Button
        size="sm"
        onClick={() => {
          window.location.reload()
        }}
      >
        Recarregar
      </Button>
    </div>
  )
}
